import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AngularFireModule } from "angularfire2";

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { OptionsComponent } from './options/options.component';
import { ProgressComponent } from './progress/progress.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { VideoAppComponent } from './video-app/video-app.component';
import { TimedisplayPipe } from './timedisplay.pipe';
import { EscapeHtmlPipe } from './escape-html.pipe';
import { StarComponent } from './star/star.component';

export const firebaseConfig ={
  apiKey: "AIzaSyCF_MxChy_ICrdE3QJK0lGBXVvtRcnhrfg",
  authDomain: "afvideolibrary.firebaseapp.com",
  databaseURL: "https://afvideolibrary.firebaseio.com",
  projectId: "afvideolibrary",
  storageBucket: "afvideolibrary.appspot.com",
  messagingSenderId: "869306795107"
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    OptionsComponent,
    ProgressComponent,
    ToolbarComponent,
    VideoAppComponent,
    TimedisplayPipe,
    EscapeHtmlPipe,
    StarComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/app.module.ts